module.exports = __webpack_public_path__ + "img/DE01658.31c7a570.png";